module.exports = __webpack_public_path__ + "static/foodcare-3ee545e5ff218642e408f1a64687abec.png";